import React from 'react'

const ArrowRightUp = ({ fill = 'currentColor', width='16', height='16' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3699_10057)">
        <path d="M8.66667 10.7813L12.2427 7.20534L13.1853 8.14801L8 13.3333L2.81467 8.14801L3.75733 7.20534L7.33333 10.7813V2.66667H8.66667V10.7813Z" fill={fill}/>
      </g>
      <defs>
        <clipPath id="clip0_3699_10057">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default ArrowRightUp
